import { render, staticRenderFns } from "./CreateReductionModal.vue?vue&type=template&id=0195ee37&"
import script from "./CreateReductionModal.vue?vue&type=script&lang=js&"
export * from "./CreateReductionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateReductionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports